import React, { useContext, useState } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import MainComponent from "./src/components/main-component/MainComponent";
import FeedComponent from "./src/components/feed-component/FeedComponent";
import AboutComponent from "./src/components/about-component/AboutComponent";
import ExperienceComponent from "./src/components/experience-component/ExperienceComponent";
import SkillsComponent from "./src/components/skills-component/SkillsComponent";
import ProjectsComponent from "./src/components/projects-component/ProjectsComponent";
import BlogsComponent from "./src/components/blogs-component/BlogsComponent";
import FooterComponent from "./src/components/footer-component/FooterComponent";
import CommonContext from "./src/utils/contexts/CommonContext";
import useThemeSwitcher from "./src/utils/custom-hooks/useThemeSwitcher";
import AiComponent from "./src/components/ai-component/AiComponent";
import ErrorComponent from "./src/components/error-component/ErrorComponent";
import EducationComponent from "./src/components/education-component/EducationComponent";

const ApplicationRoot = () => {
    const { theme } = useContext(CommonContext);

    const [themeStatus, setThemeStatus] = useState(theme);

    const result = useThemeSwitcher(themeStatus.mode);

    return (
        <div className="class-hari" style={{ backgroundColor: result.styles.background }}>
            <div className="hs">
                <CommonContext.Provider value={{ theme: result, setThemeStatus }}>
                    <MainComponent />

                    <AiComponent />

                    <div className="outlet-component">
                        <Outlet />
                    </div>

                    <FooterComponent />
                </CommonContext.Provider>
            </div>
        </div>
    );
};

const routerConfiguration = createBrowserRouter([
    {
        path: "/",
        element: <ApplicationRoot />,
        errorElement: <ErrorComponent />,
        children: [
            {
                path: "/",
                element: <AboutComponent />,
            },
            {
                path: "/feed/",
                element: <FeedComponent />,
            },
            {
                path: "/about/",
                element: <AboutComponent />,
            },
            {
                path: "/education/",
                element: <EducationComponent />,
            },
            {
                path: "/experience/",
                element: <ExperienceComponent />,
            },
            {
                path: "/skills/",
                element: <SkillsComponent />,
            },
            {
                path: "/projects/:filter?",
                element: <ProjectsComponent />,
            },
            {
                path: "/blogs/",
                element: <BlogsComponent />,
            },
        ],
    },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={routerConfiguration} />);
